import { ModalsReducerAction, ModalsReducerState } from '@/types/reducers';
import { mapValues } from 'lodash';

export function modalsReducer(state: ModalsReducerState, action: ModalsReducerAction) {
  switch (action.type) {
    case 'OPEN':
      return { ...mapValues(state, () => false), [action.payload]: true };
    case 'CLOSE':
      return { ...mapValues(state, () => false), [action.payload]: false };
  }
}
